// if (!customElements.get('variant-selects')) {

//   /**
//    *  @class
//    *  @function VariantSelects
//    */
//   class VariantSelects extends HTMLElement {
//     constructor() {
//       super();
//       this.sticky = this.dataset.sticky;
//       this.updateUrl = this.dataset.updateUrl === 'true';
//       this.isDisabledFeature = this.dataset.isDisabled;
//       this.addEventListener('change', this.onVariantChange);
//       this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
//         return selector != this;
//       });

//       this.productWrapper = this.closest('.thb-product-detail');
//       this.productSlider = this.productWrapper?.querySelector('.product-images');
//       this.hideVariants = this.dataset.hideVariants === 'true';
//     }

//     connectedCallback() {
//       this.updateOptions();
//       this.updateMasterId();
//       this.setDisabled();
//       this.setImageSet();
//     }

//     onVariantChange() {
//       this.updateOptions();
//       this.updateMasterId();
//       this.toggleAddButton(true, '', false);
//       this.updatePickupAvailability();
//       this.removeErrorMessage();
//       this.updateVariantText();
//       this.setDisabled();

//       if (!this.currentVariant) {
//         this.toggleAddButton(true, '', true);
//         this.setUnavailable();
//       } else {
//         this.updateMedia();
//         if (this.updateUrl) {
//           this.updateURL();
//         }
//         this.updateVariantInput();
//         this.renderProductInfo();
//         //this.updateShareUrl();
//       }

//       this.updateOther();
//       dispatchCustomEvent('product:variant-change', {
//         variant: this.currentVariant,
//         sectionId: this.dataset.section
//       });
//     }

//     updateOptions() {
//       this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
//       this.options = [];
//       this.fieldsets.forEach((fieldset, i) => {
//         if (fieldset.querySelector('select')) {
//           this.options.push(fieldset.querySelector('select').value);
//         } else if (fieldset.querySelectorAll('input').length) {
//           this.options.push(fieldset.querySelector('input:checked').value);
//         }
//       });
//     }
//     updateVariantText() {
//       const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//       fieldsets.forEach((item, i) => {
//         let label = item.querySelector('.form__label__value');
//         if (label) {
//           label.innerHTML = this.options[i];
//         }
//       });
//     }
//     updateMasterId() {
//       this.currentVariant = this.getVariantData().find((variant) => {
//         return !variant.options.map((option, index) => {
//           return this.options[index] === option;
//         }).includes(false);
//       });
//     }

//     updateOther() {
//       if (this.dataset.updateUrl === 'false') {
//         return;
//       }
//       if (this.other.length) {
//         let fieldsets = this.other[0].querySelectorAll('fieldset'),
//           fieldsets_array = Array.from(fieldsets);
//         this.options.forEach((option, i) => {
//           if (fieldsets_array[i].querySelector('select')) {
//             fieldsets_array[i].querySelector(`select`).value = option;
//           } else if (fieldsets_array[i].querySelectorAll('input').length) {
//             fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
//           }
//         });
//         this.other[0].updateOptions();
//         this.other[0].updateMasterId();
//         this.other[0].updateVariantText();
//         this.other[0].setDisabled();
//       }
//     }
//     updateMedia() {
//       if (!this.currentVariant) return;
//       if (!this.currentVariant.featured_media) return;

//       let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

//       this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
//     }
//     setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
//       console.log('mediaId==========>', mediaId);
//       console.log('thumbId==========>', thumbId);
//       console.log('productSlider==========>', productSlider);
//       console.log('thumbnails==========>', thumbnails)
//       let flkty = Flickity.data(productSlider),
//         activeMedia = productSlider.querySelector(mediaId);
//       if (flkty && this.hideVariants) {
//         if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
//           productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
//         }
//         [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
//           el.classList.remove('is-active');
//         });

//         activeMedia.classList.add('is-active');
//         activeMedia.classList.add('is-initial-selected');

//         this.setImageSetMedia();

//         if (thumbnails) {
//           let activeThumb = thumbnails.querySelector(thumbId);

//           if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
//             thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
//           }
//           [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
//             el.classList.remove('is-active');
//           });

//           activeThumb.classList.add('is-active');
//           activeThumb.classList.add('is-initial-selected');
//         }

//         productSlider.reInit(this.imageSetIndex);
//         productSlider.selectCell(mediaId);

//       } else if (flkty) {
//         productSlider.selectCell(mediaId);
//       }

//     }

//     updateURL() {
//       if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
//       window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//     }

//     updateShareUrl() {
//       const shareButton = document.getElementById(`Share-${this.dataset.section}`);
//       if (!shareButton) return;
//       shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
//     }

//     updateVariantInput() {
//       const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
//       productForms.forEach((productForm) => {
//         const input = productForm.querySelector('input[name="id"]');
//         input.value = this.currentVariant.id;
//         input.dispatchEvent(new Event('change', {
//           bubbles: true
//         }));
//       });
//     }

//     updatePickupAvailability() {
//       const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

//       if (!pickUpAvailability) return;

//       if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
//         pickUpAvailability.fetchAvailability(this.currentVariant.id);
//       } else {
//         pickUpAvailability.removeAttribute('available');
//         pickUpAvailability.innerHTML = '';
//       }
//     }

//     removeErrorMessage() {
//       const section = this.closest('section');
//       if (!section) return;

//       const productForm = section.querySelector('product-form');
//       if (productForm) productForm.handleErrorMessage();
//     }

//     getSectionsToRender() {
//       return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
//     }

//     renderProductInfo() {
//       let sections = this.getSectionsToRender();

//       fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
//         .then((response) => response.text())
//         .then((responseText) => {
//           const html = new DOMParser().parseFromString(responseText, 'text/html');

//           sections.forEach((id) => {
//             const destination = document.getElementById(id);
//             const source = html.getElementById(id);

//             if (source && destination) destination.innerHTML = source.innerHTML;

//             const price = document.getElementById(id);
//             const price_fixed = document.getElementById(id + '--sticky');

//             if (price) price.classList.remove('visibility-hidden');
//             if (price_fixed) price_fixed.classList.remove('visibility-hidden');

//           });
//           this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

//         });
//     }

//     toggleAddButton(disable = true, text = false, modifyClass = true) {
//       const productForm = document.getElementById(`product-form-${this.dataset.section}`);
//       if (!productForm) return;

//       const productTemplate = productForm.closest('.product-form').getAttribute('template');
//       const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

//       if (!submitButtons) return;

//       submitButtons.forEach((submitButton) => {
//         const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

//         if (!submitButtonText) return;

//         if (disable) {
//           submitButton.setAttribute('disabled', 'disabled');
//           if (text) submitButtonText.dataset.content = text;
//         } else {
//           submitButton.removeAttribute('disabled');
//           submitButton.classList.remove('loading');

//           if (productTemplate?.includes('pre-order')) {
//             submitButtonText.dataset.content = window.theme.variantStrings.preOrder;
//           } else {
//             submitButtonText.dataset.content = window.theme.variantStrings.addToCart;
//           }
//         }
//       });

//       if (!modifyClass) return;
//     }

//     setUnavailable() {
//       const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
//       const price = document.getElementById(`price-${this.dataset.section}`);
//       const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

//       submitButtons.forEach((submitButton) => {
//         const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
//         if (!submitButton) return;
//         submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
//         submitButton.classList.add('sold-out');
//       });
//       if (price) price.classList.add('visibility-hidden');
//       if (price_fixed) price_fixed.classList.add('visibility-hidden');
//     }

//     setDisabled() {
//       if (this.isDisabledFeature != 'true') {
//         return;
//       }
//       const variant_data = this.getVariantData();

//       if (variant_data && this.currentVariant) {

//         const selected_options = this.currentVariant.options.map((value, index) => {
//           return {
//             value,
//             index: `option${index + 1}`
//           };
//         });
//         const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


//         this.fieldsets.forEach((fieldset, i) => {
//           const fieldset_options = Object.values(available_options)[i];

//           if (fieldset_options) {
//             if (fieldset.querySelector('select')) {
//               fieldset_options.forEach((option, option_i) => {
//                 if (option.isUnavailable) {
//                   fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
//                 } else {
//                   fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
//                 }
//               });
//             } else if (fieldset.querySelectorAll('input').length) {
//               fieldset.querySelectorAll('input').forEach((input, input_i) => {
//                 input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
//               });
//             }
//           }
//         });

//       }
//       return true;
//     }

//     getImageSetName(variant_name) {
//       return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
//     }

//     setImageSet() {
//       if (!this.productSlider) return;

//       let dataSetEl = this.productSlider.querySelector('[data-set-name]');
//       if (dataSetEl) {
//         this.imageSetName = dataSetEl.dataset.setName;
//         console.log('this.imageSetName===========>', this.imageSetName);
//         this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
//         this.dataset.imageSetIndex = this.imageSetIndex;

//         this.setImageSetMedia();
//       }
//     }
//     setImageSetMedia() {
//       if (!this.imageSetIndex) {
//         return;
//       }

//       let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
//       let group = this.imageSetName + '_' + setValue;
//       console.log('group============>', group);
//       let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
//         selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

//       if (this.hideVariants) {
//         // Product images
//         this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
//           if (thumb.dataset.group && thumb.dataset.group !== group) {
//             thumb.classList.remove('is-active');
//           }
//         });
//         selected_set_images.forEach(thumb => {
//           thumb.classList.toggle('is-active', thumb.dataset.group === group);
//         });

//         // Product thumbnails
//         this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
//           if (thumb.dataset.group && thumb.dataset.group !== group) {
//             thumb.classList.remove('is-active');
//           }
//         });
//         selected_set_thumbs.forEach(thumb => {
//           thumb.classList.toggle('is-active', thumb.dataset.group === group);
//         });
//       }

//     }

//     createAvailableOptionsTree(variant_data, selected_options) {
//       // Reduce variant array into option availability tree
//       return variant_data.reduce((options, variant) => {

//         // Check each option group (e.g. option1, option2, option3) of the variant
//         Object.keys(options).forEach(index => {

//           if (variant[index] === null) return;

//           let entry = options[index].find(option => option.value === variant[index]);

//           if (typeof entry === 'undefined') {
//             // If option has yet to be added to the options tree, add it
//             entry = {
//               value: variant[index],
//               isUnavailable: true
//             };
//             options[index].push(entry);
//           }

//           // Check how many selected option values match a variant
//           const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
//             value,
//             index
//           }) => {
//             return variant[index] === value ? count + 1 : count;
//           }, 0);

//           // Only enable an option if an available variant matches all but one current selected value
//           if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
//             entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
//           }

//           // Make sure if a variant is unavailable, disable currently selected option
//           if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
//             entry.isUnavailable = true;
//           }

//           // First option is always enabled
//           if (index === 'option1') {
//             entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
//           }
//         });

//         return options;
//       }, {
//         option1: [],
//         option2: [],
//         option3: []
//       });
//     }

//     getVariantData() {
//       this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
//       return this.variantData;
//     }
//   }
//   customElements.define('variant-selects', VariantSelects);

//   /**
//    *  @class
//    *  @function VariantRadios
//    */
//   class VariantRadios extends VariantSelects {
//     constructor() {
//       super();
//     }

//     updateOptions() {
//       const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//       this.options = fieldsets.map((fieldset) => {
//         return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
//       });
//     }
//   }

//   customElements.define('variant-radios', VariantRadios);
// }
if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper?.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
      
      // New color-based image filtering properties
      this.colorImageRanges = {};
      this.colorImageIDs = {};
      this.colorOption = null;
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      
      // Initialize color-based image filtering instead of alt tag based
      this.initColorBasedFiltering();
    }

    // New method: Initialize color-based image filtering
    async initColorBasedFiltering() {
      const productHandle = this.dataset.productHandle || window.location.pathname.split('/products/')[1]?.split('?')[0];
      
      if (!productHandle) {
        console.warn('Product handle not found');
        return;
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
        const product = await response.json();
        
        // Get options to watch from dataset or default
        const optionsToWatch = (this.dataset.colorOptions || 'Renk,Color,Colour,color,colour').split(',');
        this.colorOption = product.options.find(option => optionsToWatch.includes(option.name)) || null;
        
        if (!this.colorOption) {
          console.warn("No color option found for this product.");
          return;
        }

        const colorValues = this.colorOption.values;
        const colorImagePositions = {};
        
        // Get image positions for each color
        colorValues.forEach(color => {
          const variant = product.variants.find(v => v.options[this.colorOption.position - 1] === color);
          if (variant && variant.featured_image) {
            colorImagePositions[color] = variant.featured_image.position;
          }
        });

        // Sort colors by image position
        const sortedColors = Object.entries(colorImagePositions).sort((a, b) => a[1] - b[1]);
        
        // Calculate image ranges for each color
        sortedColors.forEach((color, index) => {
          const colorName = color[0];
          const startPos = color[1];
          const endPos = sortedColors[index + 1] ? sortedColors[index + 1][1] : null;
          this.colorImageRanges[colorName] = endPos ? [startPos, endPos] : [startPos];
        });

        // Map color to media IDs
        Object.entries(this.colorImageRanges).forEach(([color, range]) => {
          const startPos = range[0];
          const endPos = range[1] || product.media.length + 1;
          
          const imageIDs = product.media
            .filter((media, index) => {
              const imagePosition = index + 1;
              return imagePosition >= startPos && imagePosition < endPos;
            })
            .map(media => media.id);

          this.colorImageIDs[color] = imageIDs;
        });

        // Set data-media-group attributes
        this.setMediaGroupAttributes();
        
        // Show initial variant images
        this.showVariantImages();
        
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    }

    // New method: Set data-media-group attributes on media items
    setMediaGroupAttributes() {
      if (!this.productSlider) return;
      
      const sectionId = this.dataset.section;
      
      Object.entries(this.colorImageIDs).forEach(([color, imageIDs]) => {
        imageIDs.forEach(mediaID => {
          const selectors = [
            `[data-media-id="${sectionId}-${mediaID}"]`,
            `[data-target="${sectionId}-${mediaID}"]`,
            `#Slide-${sectionId}-${mediaID}`,
            `#Thumb-${sectionId}-${mediaID}`
          ];
          
          selectors.forEach(selector => {
            const mediaItems = this.productWrapper.querySelectorAll(selector);
            mediaItems.forEach(mediaItem => {
              mediaItem.setAttribute('data-media-group', color);
            });
          });
        });
      });
    }

    // New method: Show/hide images based on selected color
    showVariantImages() {
      if (!this.colorOption || !this.productSlider) return;
      
      // Find selected color value
      const selectedColor = this.options.find(value => this.colorImageRanges.hasOwnProperty(value));
      console.log('selectedColor========>',selectedColor);
      if (!selectedColor) return;

      // Show/hide product slides
      const slides = this.productSlider.querySelectorAll('.product-images__slide[data-media-group]');
      slides.forEach(slide => {
        if (slide.getAttribute('data-media-group') === selectedColor) {
          slide.classList.remove('hidden');
          slide.classList.add('is-active');
        } else {
          slide.classList.add('hidden');
          slide.classList.remove('is-active');
        }
      });

      // Show/hide thumbnails
      const thumbnailContainer = this.productWrapper?.querySelector('.product-thumbnail-container');
      if (thumbnailContainer) {
        const thumbnails = thumbnailContainer.querySelectorAll('.product-thumbnail[data-media-group]');
        thumbnails.forEach(thumb => {
          if (thumb.getAttribute('data-media-group') === selectedColor) {
            thumb.classList.remove('hidden');
            thumb.classList.add('is-active');
          } else {
            thumb.classList.add('hidden');
            thumb.classList.remove('is-active');
          }
        });
      }

      // Reinitialize slider
      this.reinitSlider();
    }

    // New method: Reinitialize the product slider
    reinitSlider() {
      if (this.productSlider && typeof this.productSlider.reInit === 'function') {
        setTimeout(() => {
          this.productSlider.reInit();
        }, 100);
      }
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        // Use new color-based image filtering instead of updateMedia
        this.showVariantImages();
        this.updateSelectedMedia();
        
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    // New method: Update selected media (scroll to variant's featured image)
    updateSelectedMedia() {
      if (!this.currentVariant || !this.currentVariant.featured_media) return;
      
      const mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      
      if (this.productSlider && typeof this.productSlider.selectCell === 'function') {
        setTimeout(() => {
          this.productSlider.selectCell(mediaId);
        }, 150);
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.dataset.content = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.dataset.content = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.dataset.content = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data && this.currentVariant) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      return variant_data.reduce((options, variant) => {
        Object.keys(options).forEach(index => {
          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
// if (!customElements.get('product-slider')) {
//   /**
//    *  @class
//    *  @function ProductSlider
//    */
//   class ProductSlider extends HTMLElement {
//     constructor() {
//       super();

//       this.addEventListener('change', this.setupProductGallery);
//     }
//     connectedCallback() {
//       this.product_container = this.closest('.thb-product-detail');
//       this.quickView = this.closest('#Product-Drawer-Content');
//       this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
//       this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
//       this.progress_bar = this.product_container.querySelector('.flickity-progress--bar'),

//         this.setOptions();
//       // Start Slider
//       this.init();
//     }
//     setOptions() {
//       this.hide_variants = this.dataset.hideVariants == 'true';
//       this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
//       this.prev_button = this.querySelector('.flickity-prev');
//       this.next_button = this.querySelector('.flickity-next');
//       this.images = this.querySelectorAll('img');
//       this.options = {
//         wrapAround: true,
//         pageDots: true,
//         contain: true,
//         cellAlign: this.quickView ? 'left' : 'right',
//         adaptiveHeight: !this.quickView,
//         initialIndex: '.is-initial-selected',
//         prevNextButtons: false,
//         fade: false,
//         cellSelector: '.product-images__slide.is-active',
//         on: {
//           ready: () => {
//             this.images.forEach((img) => {
//               img.addEventListener('lazyloaded', () => {
//                 this.flkty.resize();
//               });
//             });
//           },
//           dragStart: () => {
//             this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
//           },
//           dragEnd: () => {
//             this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
//           }
//         }
//       };
//       if (this.quickView) {
//         this.options.wrapAround = false;
//       }
//       if (this.progress_bar) {
//         this.options.on.scroll = (progress) => {
//           progress = Math.max(0, Math.min(1, progress));
//           this.progress_bar.style.width = progress * 100 + '%';
//         };
//       }
//     }
//     init() {
//       this.flkty = new Flickity(this, this.options);

//       this.selectedIndex = this.flkty.selectedIndex;

//       // Setup Events
//       this.setupEvents();

//       // Start Gallery
//       this.setupProductGallery();
//     }
//     reInit(imageSetIndex) {
//       this.flkty.destroy();

//       this.setOptions();

//       this.flkty = new Flickity(this, this.options);

//       // Setup Events
//       this.setupEvents();

//       this.selectedIndex = this.flkty.selectedIndex;
//     }
//     setupEvents() {
//       const _this = this;
//       if (this.prev_button) {
//         let prev = this.prev_button.cloneNode(true);
//         this.prev_button.parentNode.append(prev);
//         this.prev_button.remove();
//         prev.addEventListener('click', (event) => {
//           this.flkty.previous();
//         });
//         prev.addEventListener('keyup', (event) => {
//           this.flkty.previous();
//           event.preventDefault();
//         });
//       }
//       if (this.next_button) {
//         let next = this.next_button.cloneNode(true);
//         this.next_button.parentNode.append(next);
//         this.next_button.remove();
//         next.addEventListener('click', (event) => {
//           this.flkty.next();
//         });
//         next.addEventListener('keyup', (event) => {
//           this.flkty.next();
//           event.preventDefault();
//         });
//       }
//       this.video_containers.forEach((container) => {
//         container.querySelector('button').addEventListener('click', function () {
//           container.setAttribute('hidden', '');
//         });
//       });
//       this.flkty.on('settle', function (index) {
//         _this.selectedIndex = index;
//       });
//       this.flkty.on('change', (index) => {

//         let previous_slide = this.flkty.cells[_this.selectedIndex].element,
//           previous_media = previous_slide.querySelector('.product-single__media');

//         if (this.thumbnails) {
//           let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
//             active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

//           this.thumbnails.forEach((item, i) => {
//             item.classList.remove('is-initial-selected');
//           });
//           active_thumb.classList.add('is-initial-selected');

//           requestAnimationFrame(() => {
//             if (active_thumb.offsetParent === null) {
//               return;
//             }
//             const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
//               windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
//             active_thumb.parentElement.scrollTo({
//               left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
//               top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
//               behavior: 'smooth'
//             });
//           });
//         }


//         // Stop previous video
//         if (previous_media.classList.contains('product-single__media-external-video')) {
//           if (previous_media.dataset.provider === 'youtube') {
//             previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
//               event: "command",
//               func: "pauseVideo",
//               args: ""
//             }), "*");
//           } else if (previous_media.dataset.provider === 'vimeo') {
//             previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
//               method: "pause"
//             }), "*");
//           }
//           previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
//         } else if (previous_media.classList.contains('product-single__media-native-video')) {
//           previous_media.querySelector('video').pause();
//         }

//       });

//       if (this.thumbnails && !this.thumbnail_container.dataset.init) {
//         setTimeout(() => {
//           let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
//           active_thumbs.forEach((thumbnail, index) => {
//             thumbnail.addEventListener('click', () => {
//               this.thumbnailClick(thumbnail, index);
//             });
//           });
//           this.thumbnail_container.addEventListener('click', (e) => {
//             let count = Math.min(Math.max(this.thumbnail_container.querySelectorAll('.is-active').length, 1), 4);
//             this.thumbnail_container.style.setProperty('--thumbnail-width', (count * 63) + 19 + 'px');
//             if (!this.thumbnail_container.classList.contains('extended')) {
//               this.thumbnail_container.classList.add('extended');
//             } else {
//               if (e.target.nodeName == 'BUTTON') {
//                 this.thumbnail_container.classList.remove('extended');
//               }
//               e.preventDefault();
//             }
//             if (!this.thumbnail_container.classList.contains('extended')) {
//               let active_thumb = this.thumbnail_container.querySelector('.is-initial-selected');
//               setTimeout(() => {
//                 active_thumb.parentElement.scrollTo({
//                   left: Math.max(active_thumb.offsetLeft, 0),
//                   top: 0,
//                   behavior: 'smooth'
//                 });
//               }, 300);
//             }
//           });
//           this.thumbnail_container.dataset.init = true;
//         });
//       }
//     }
//     thumbnailClick(thumbnail, index) {
//       [].forEach.call(this.thumbnails, function (el) {
//         el.classList.remove('is-initial-selected');
//       });
//       thumbnail.classList.add('is-initial-selected');
//       this.flkty.select(index);
//     }
//     setDraggable(draggable) {
//       this.flkty.options.draggable = draggable;
//       this.flkty.updateDraggable();
//     }
//     selectCell(mediaId) {
//       this.flkty.selectCell(mediaId);
//     }
//     setupProductGallery() {
//       if (!this.querySelectorAll('.product-single__media-zoom').length) {
//         return;
//       }
//       this.setEventListeners();
//     }
//     buildItems() {
//       this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

//       return this.activeImages.map((item) => {
//         let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

//         let activelink = item.querySelector('.product-single__media-zoom');

//         activelink.dataset.index = index;
//         return {
//           src: activelink.getAttribute('href'),
//           msrc: activelink.dataset.msrc,
//           w: activelink.dataset.w,
//           h: activelink.dataset.h
//         };
//       });
//     }
//     setEventListeners() {
//       this.links = this.querySelectorAll('.product-single__media-zoom');
//       this.pswpElement = document.querySelectorAll('.pswp')[0];
//       this.pswpOptions = {
//         maxSpreadZoom: 2,
//         loop: false,
//         allowPanToNext: false,
//         closeOnScroll: false,
//         showHideOpacity: false,
//         arrowKeys: true,
//         history: false,
//         captionEl: false,
//         fullscreenEl: false,
//         zoomEl: false,
//         shareEl: false,
//         counterEl: true,
//         arrowEl: true,
//         preloaderEl: true,
//         getThumbBoundsFn: () => {
//           const thumbnail = this.querySelector('.product-images__slide.is-selected'),
//             pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
//             rect = thumbnail.getBoundingClientRect();
//           return {
//             x: rect.left,
//             y: rect.top + pageYScroll,
//             w: rect.width
//           };
//         }
//       };


//       this.links.forEach((link => {
//         link.addEventListener('click', (e) => this.zoomClick(e, link));
//       }));
//     }
//     zoomClick(e, link) {
//       this.items = this.buildItems();
//       this.pswpOptions.index = parseInt(link.dataset.index, 10);
//       if (typeof PhotoSwipe !== 'undefined') {
//         let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
//         pswp.listen('firstUpdate', function () {
//           pswp.listen('parseVerticalMargin', function (item) {
//             item.vGap = {
//               top: 50,
//               bottom: 50
//             };
//           });
//         });
//         pswp.init();
//       }
//       e.preventDefault();
//     }
//   }
//   customElements.define('product-slider', ProductSlider);
// }
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.quickView = this.closest('#Product-Drawer-Content');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.progress_bar = this.product_container.querySelector('.flickity-progress--bar'),

      console.log('this.quickView===========>', this.quickView);
      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
      // this.prev_button = this.querySelector('.flickity-prev');
      // this.next_button = this.querySelector('.flickity-next');
      this.images = this.querySelectorAll('img');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        cellAlign: this.quickView ? 'left' : 'left',
        adaptiveHeight: !this.quickView,
        setGallerySize: false,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        rightToLeft: document.dir === 'rtl',
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        on: {
          ready: () => {
            this.images.forEach((img) => {
              img.addEventListener('lazyloaded', () => {
                this.flkty.resize();
              });
            });
          },
          dragStart: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
          },
          dragEnd: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
          }
        }
      };
      if (this.quickView) {
        this.options.wrapAround = false;
      }
      if (this.progress_bar) {
        this.options.on.scroll = (progress) => {
          progress = Math.max(0, Math.min(1, progress));
          this.progress_bar.style.width = progress * 100 + '%';
        };
      }
    }
    setupCustomNav() {
      // Clone buttons to remove ALL old listeners
      const prevBtn = this.querySelector('.prev');
      const nextBtn = this.querySelector('.next');

      if (prevBtn) {
        const newPrev = prevBtn.cloneNode(true);
        prevBtn.parentNode.replaceChild(newPrev, prevBtn);
        newPrev.addEventListener('click', () => {
          this.flkty.previous();
          setTimeout(() => this.updateNavCounter(), 50);
        });
      }
      if (nextBtn) {
        const newNext = nextBtn.cloneNode(true);
        nextBtn.parentNode.replaceChild(newNext, nextBtn);
        newNext.addEventListener('click', () => {
          this.flkty.next();
          setTimeout(() => this.updateNavCounter(), 50);
        });
      }

      // Remove old change listener before adding new one
      if (this._navChangeHandler) {
        this.flkty.off('change', this._navChangeHandler);
      }
      this.flkty.on('change', () => {
        requestAnimationFrame(() => {
          this.updateNavCounter();
        });
      });

      // Initial counter update
      this.updateNavCounter();
    }
    updateNavCounter() {
      if (!this.flkty) return;

      const currentEl = this.querySelector('.current');
      const totalEl = this.querySelector('.total');

      // ✅ only visible slides
      const activeSlides = Array.from(this.querySelectorAll('.product-images__slide.is-active'))
        .filter(el => el.offsetParent !== null);

      const total = activeSlides.length;

      // ✅ use Flickity index safely
      let currentIndex = this.flkty.selectedIndex;

      // ❗ FIX: if index exceeds visible slides
      if (currentIndex >= total) {
        currentIndex = 0;
      }

      if (currentEl) currentEl.textContent = currentIndex + 1;
      if (totalEl) totalEl.textContent = total;
    }

    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();

      this.setupCustomNav();
      this.setupCustomNav();
      this.updateNavCounter()
      requestAnimationFrame(() => {
        this.updateNavCounter();
      }); 
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
      this.updateNavCounter()
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          document.dir === 'rtl' ? this.flkty.next() : this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          document.dir === 'rtl' ? this.flkty.next() : this.flkty.previous();
          event.preventDefault();
        });
        this.querySelector('.prev')?.addEventListener('click', () => {
          this.flkty.previous();
        });

        this.querySelector('.next')?.addEventListener('click', () => {
          this.flkty.next();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          document.dir === 'rtl' ? this.flkty.previous() : this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          document.dir === 'rtl' ? this.flkty.previous() : this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        if (this.thumbnails) {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
            active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove('is-initial-selected');
          });
          active_thumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }


        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });

      if (this.thumbnails && !this.thumbnail_container.dataset.init) {
        setTimeout(() => {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
          this.thumbnail_container.addEventListener('click', (e) => {
            let count = Math.min(Math.max(this.thumbnail_container.querySelectorAll('.is-active').length, 1), 4);
            this.thumbnail_container.style.setProperty('--thumbnail-width', (count * 63) + 19 + 'px');
            if (!this.thumbnail_container.classList.contains('extended')) {
              this.thumbnail_container.classList.add('extended');
            } else {
              if (e.target.nodeName == 'BUTTON') {
                this.thumbnail_container.classList.remove('extended');
              }
              e.preventDefault();
            }
            if (!this.thumbnail_container.classList.contains('extended')) {
              let active_thumb = this.thumbnail_container.querySelector('.is-initial-selected');
              setTimeout(() => {
                active_thumb.parentElement.scrollTo({
                  left: Math.max(active_thumb.offsetLeft, 0),
                  top: 0,
                  behavior: 'smooth'
                });
              }, 300);
            }
          });
          this.thumbnail_container.dataset.init = true;
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}
/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      // const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      // submitButtons.forEach((submitButton) => {
      //   if (submitButton.classList.contains('loading')) return;
      //   submitButton.setAttribute('aria-disabled', true);
      //   submitButton.classList.add('loading');
      // });
      const isCompleteLook = evt.submitter && evt.submitter.classList.contains('complete-look-add-btn');

      let submitButtons = [];

      if (!isCompleteLook) {
        submitButtons = document.querySelectorAll('.single-add-to-cart-button');

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains('loading')) return;
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        });
      }


      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
          if (document.querySelector('.product-add-to-cart-sticky-modal')) {
            document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
          }
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        if (section.id == 'Cart-Drawer') {
          elementToReplace.removeProductEvent();
          elementToReplace.notesToggle();
          elementToReplace.termsCheckbox();
          elementToReplace.updateFreeShipping();
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupObservers();
      this.drawer = document.getElementById(this.dataset.target);
      this.addEventListener('click', this.onClick.bind(this));
    }
    onClick() {
      this.drawer.show();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}






window.theme = window.theme || {};
window.theme.moneyFormat =
  window.theme.moneyFormat ||
  document.body.dataset.moneyFormat ||
  '{{ amount }}';

function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    number = (number / 100).toFixed(precision);
    const parts = number.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
  if (!match) return cents;

  switch (match[1]) {
    case 'amount':
      return formatWithDelimiters(cents, 2);
    case 'amount_no_decimals':
      return formatWithDelimiters(cents, 0);
    case 'amount_with_comma_separator':
      return formatWithDelimiters(cents, 2, '.', ',');
    case 'amount_no_decimals_with_comma_separator':
      return formatWithDelimiters(cents, 0, '.', ',');
  }
}

document.addEventListener('change', function (e) {
  const select = e.target;
  if (!select.closest('.complete-look-form')) return;

  const form = select.closest('.complete-look-form');
  const item = select.closest('.complete-look-item');

  const variantsEl = item.querySelector('.complete-look-variants');
  if (!variantsEl) return;

  const variants = JSON.parse(variantsEl.textContent);

  const selectedOptions = Array.from(
    form.querySelectorAll('select[name^="options"]')
  ).map((s) => s.value);

  const matchedVariant = variants.find((variant) =>
    variant.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!matchedVariant) return;

  const variantInput = form.querySelector('.product-variant-id');
  if (variantInput) {
    variantInput.value = matchedVariant.id;
  }

  const priceWrapper = form.querySelector('.price');
  if (priceWrapper) {
    const insAmount = priceWrapper.querySelector('ins .amount');
    const delAmount = priceWrapper.querySelector('del .amount');

    if (insAmount) {
      insAmount.innerHTML = formatMoney(
        matchedVariant.price,
        window.theme.moneyFormat
      );
    }

    if (
      matchedVariant.compare_at_price &&
      matchedVariant.compare_at_price > matchedVariant.price
    ) {
      if (delAmount) {
        delAmount.innerHTML = formatMoney(
          matchedVariant.compare_at_price,
          window.theme.moneyFormat
        );
        delAmount.closest('del').style.display = '';
      }
    } else if (delAmount) {
      delAmount.closest('del').style.display = 'none';
    }
  }

  const button = form.querySelector('.complete-look-add-btn');
  if (button) {
    if (matchedVariant.available) {
      button.disabled = false;
      button.classList.remove('disabled');
    } else {
      button.disabled = true;
      button.classList.add('disabled');
    }
  }
});



